export default {
  unlocked_plural: '{{count}} offres ont été débloquées',
  unlocked: '{{offer}} a été débloquée',
  removed_one: '{{offer}} a été supprimée',
  removed_other: '{{count}} ont été supprimées',
};
